import * as React from "react";

function IcContact(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path 
            d="M12.6477 0.693237C17.2501 0.693237 21 3.73456 21 7.47593C21 9.29994 20.0853 11.054 18.4809 12.3296L19.0508 15.5226C19.0795 15.6704 18.9981 15.8221 18.8401 15.9037C18.7587 15.9465 18.6677 15.966 18.5815 15.966C18.4905 15.966 18.3995 15.9465 18.3229 15.9037L14.7502 14.0408C14.0701 14.1847 13.3661 14.2586 12.6477 14.2586C8.04057 14.2586 4.29545 11.2173 4.29545 7.47593C4.29545 3.73456 8.04057 0.693237 12.6477 0.693237Z" 
            fill="currentColor"
        />
        <path 
            d="M12.458 15.0553C13.1054 15.0553 13.7481 15.0018 14.3717 14.8947L14.7954 15.1126C13.234 16.6879 10.8538 17.6285 8.30216 17.6285C7.5881 17.6285 6.88356 17.5596 6.21232 17.4144L2.66103 19.2458C2.58487 19.2879 2.49442 19.307 2.40397 19.307C2.31352 19.307 2.22307 19.2879 2.14692 19.2458C1.98982 19.1655 1.9089 19.0202 1.93269 18.8711L2.50395 15.732C0.909187 14.4779 -4.3869e-05 12.7536 -4.3869e-05 10.9604C-4.3869e-05 8.73129 1.37097 6.68955 3.60361 5.46606C3.34179 6.15046 3.20372 6.8731 3.20372 7.62248C3.20372 11.7212 7.35484 15.0553 12.458 15.0553Z" 
            fill="currentColor"
        />
    </svg>
  );
}

export default IcContact;
